import { render } from "./SendSmsStart.vue?vue&type=template&id=9706ea76"
import script from "./SendSmsStart.vue?vue&type=script&lang=js"
export * from "./SendSmsStart.vue?vue&type=script&lang=js"

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__